<div class="ctrip-price-tip-modal">
  <div class="item">
    {{ "ctrip-modal_price_html_desc1" | translate }}
    <!-- 1. 所有渠道均按照卖价设置，显示时为卖价，携程和飞猪除外。 -->
  </div>
  <div class="item">
    {{ "ctrip-modal_price_html_desc2" | translate }}
    <!-- 2. 携程按照卖价设置，显示时为底价。 -->
  </div>
  <div class="item">
    {{ "ctrip-modal_price_html_desc3" | translate }}
    <!-- 3. 飞猪的价格设置和显示，取决于飞猪后台的改价设置。例如，飞猪后台按照卖价设置，则在百居易设置的是卖价，显示的也是卖价。 -->
  </div>
  <div class="item">
    {{ "ctrip-modal_price_html_desc4" | translate }}
    <!-- 4. 携程可单独设置佣金，如需设置，请改价时单独点击携程的价格。 -->
  </div>
  <!-- <p class="item">
    {{ "calendar.price_info.ctrip1" | translate }}
  </p>
  <p class="item">
    {{ "calendar.price_info.ctrip2" | translate }}
  </p>
  <p class="item">
    {{ "calendar.price_info.ctrip3" | translate }}
  </p> -->

  <p class="service">
    {{ "word.has_question" | translate }}
    <!-- 如有问题，请 -->
    <span class="link" (click)="displayCustomerServiceModal()">
      {{ "word.contact_3" | translate }}
      <!-- 联系客服 -->
    </span>
  </p>
</div>
